export default __webpack_public_path__ + "static/media/blog-sealer-004.c971a007.jpg";